import React from "react";

import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
	menuItem: {
		display: 'flex',
		alignItems: 'center',
		gap: '10px',
		minHeight: '36px',
		padding: '8px 16px',
		'&.Mui-selected': {
			backgroundColor: 'transparent !important',
		},
		'&.Mui-selected:hover': {
			backgroundColor: theme.palette.action.hover + ' !important',
		},
		'&:hover': {
			backgroundColor: theme.palette.action.hover,
		},
	},
	queueCircle: {
		width: '16px',
		height: '16px',
		borderRadius: '50%',
		flexShrink: 0,
		transition: 'all 0.2s ease',
	},
	queueLabel: {
		flex: 1,
		fontSize: '0.875rem',
	},
}));

const TicketsQueueSelect = ({
	userQueues,
	selectedQueueIds = [],
	onChange,
	allowNoQueueOption = false,
}) => {
	const classes = useStyles();

	const handleChange = e => {
		const rawIds = Array.isArray(e.target.value) ? [...e.target.value] : [];
		const selectedIds = allowNoQueueOption ? rawIds : rawIds.filter(id => id !== 0);

		// Salvar no localStorage
		const companyId = localStorage.getItem("companyId");
		if (companyId) {
			localStorage.setItem(`ticketsFilters:${companyId}:queues`, JSON.stringify(selectedIds));
		}

		onChange(selectedIds);
	};

	const renderQueueCircle = (color, isSelected) => {
		return (
			<div
				className={classes.queueCircle}
				style={{
					border: `2px solid ${color}`,
					backgroundColor: isSelected ? color : 'transparent',
				}}
			/>
		);
	};

	const renderValue = () => {
		const effectiveIds = allowNoQueueOption ? selectedQueueIds : selectedQueueIds.filter(id => id !== 0);
		if (effectiveIds.length === 0) return "Filas";
		if (effectiveIds.length === 1) return "1 fila";
		return `${effectiveIds.length} filas`;
	};

	return (
		<div style={{ marginTop: -4, width: '100%' }}>
			<FormControl fullWidth margin="dense">
				<Select
					multiple
					displayEmpty
					variant="outlined"
					value={selectedQueueIds}
					onChange={handleChange}
					MenuProps={{
						anchorOrigin: {
							vertical: "bottom",
							horizontal: "left",
						},
						transformOrigin: {
							vertical: "top",
							horizontal: "left",
						},
						getContentAnchorEl: null,
					}}
					renderValue={renderValue}
				>
					{allowNoQueueOption && (
						<MenuItem
							dense
							key="no-queue"
							value={0}
							className={classes.menuItem}
						>
							{renderQueueCircle("#999", selectedQueueIds.indexOf(0) > -1)}
							<span className={classes.queueLabel}>Sem Fila</span>
						</MenuItem>
					)}
					{userQueues?.length > 0 &&
						userQueues.map(queue => (
							<MenuItem
								dense
								key={queue.id}
								value={queue.id}
								className={classes.menuItem}
							>
								{renderQueueCircle(queue.color, selectedQueueIds.indexOf(queue.id) > -1)}
								<span className={classes.queueLabel}>{queue.name}</span>
							</MenuItem>
						))}
				</Select>
			</FormControl>
		</div>
	);
};

export default TicketsQueueSelect;
